<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/inventory'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :ref="'intake-season'"
    :defaultUserSettings="false"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { IntakeSeasonService } from "../../../_services/api/settings/inventory/intake-season.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Season: null,
        StartDate: undefined,
        EndDate: undefined,
        Notes: undefined,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Seasons",
        pageRoute: "/season",
        saveEndPoint: "AlmondcoIntakeSeason",
        updateEndPoint: "AlmondcoIntakeSeason",
        recordEndPoint: "AlmondcoIntakeSeason",
        // isDefaultEndPoint: "AlmondcoIntakeSeason/SaveDefault",
        exportFileName: "Seasons List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoIntakeSeason",
              filter: "",
              //   select: [
              //     "Code",
              //     "Description",
              //     "Inactive",
              //     "IsDefault",
              //     "RecordId",
              //   ],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.intakeSeasonPostProcessCallback,
            },
            rowSelect: {
              view: this,
              page: "season",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: true,
            openFilter: false,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/season/create",
                clickAction: () => {
                  this.goToCreateSeason();
                },
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "EstimateSeason",
              label: "Season",
              alignment: "left",
              sortOrder: "asc",
              sortIndex: 0,
              width: 110,
            },
            {
              screenField: "DateIn",
              dataField: "StartDate",
              label: "Start Date",
            },
            {
              screenField: "DateIn",
              dataField: "EndDate",
              label: "End Date",
            },
            {
              dataField: "Notes",
              label: "Notes",
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          editCallBack: () => {
            this.beforeInit();
          },
          delete: this.baseView.mode != 'create' && this.recordEditable,
          deleteCallBack: () => {
            this.deleteIntakeSeason();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Season",
                editorType: "dxNumberBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Season" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
              {
                dataField: "StartDate",
                label: { text: "Start Date" },
                allowUpdate: this.recordEditable,
                editorType: "dxDateBox",
                editorOptions: {
                  displayFormat: "dd MMM yyyy",
                  useMaskBehavior: true,
                  showClearButton: true,
                  onValueChanged: (e) => {
                    var instance =
                      this.$refs["intake-season"].$refs["split-view-form"]
                        .$refs["gc-form-comp"].instance;

                    var editor = instance.getEditor("EndDate");
                    editor.option("min", e.value);
                    this.reValidation();
                  },
                  tabIndex: 2,
                },
                validationRules: [
                  {
                    type: "required",
                    message: "Start Date is required",
                  },
                  {
                    type: "custom",
                    validationCallback: ({ value, rule }) => {
                      rule.message = `Start Date can not be greater than the End Date`;
                      return value < this.formModel.EndDate;
                    },
                    reevaluate: true,
                  },
                ],
              },
              {
                dataField: "EndDate",
                label: { text: "End Date" },
                allowUpdate: this.recordEditable,
                editorType: "dxDateBox",
                editorOptions: {
                  displayFormat: "dd MMM yyyy",
                  useMaskBehavior: true,
                  showClearButton: true,
                  onValueChanged: (e) => {
                    var instance =
                      this.$refs["intake-season"].$refs["split-view-form"]
                        .$refs["gc-form-comp"].instance;

                    var editor = instance.getEditor("StartDate");
                    editor.option("max", e.value);
                    this.reValidation();
                  },
                  tabIndex: 3,
                },
                validationRules: [
                  {
                    type: "required",
                    message: "End Date is required",
                  },
                  {
                    type: "custom",
                    validationCallback: ({ value, rule }) => {
                      rule.message =
                        "End Date can not be less than the Start Date";
                      return value > this.formModel.StartDate;
                    },
                    reevaluate: true,
                  },
                ],
              },
              {
                dataField: "Notes",
                label: { text: "Note" },
                editorType: "dxTextArea",
                editorOptions: {
                  maxLength: 1000,
                  tabIndex: 4,
                },
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    goToCreateSeason() {
      this.$router
        .push({
          path: `/season/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    reValidation() {
      var instance =
        this.$refs["intake-season"].$refs["split-view-form"].$refs[
          "gc-form-comp"
        ].instance;

      setTimeout(() => {
        instance.validate();
      }, 10);
    },
    intakeSeasonPostProcessCallback(data) {
      data.forEach((element) => {
        element.StartDate = element.StartDate.dateWithOffset();
        element.EndDate = element.EndDate.dateWithOffset();
      });
      return data;
    },
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        // this.setLoading = true;
        // ProductService.getProductData(
        //   `AlmondcoIntakeSeasonCode eq '${this.baseView.id}'`
        // )
        //   .then((res) => {
        //     this.setLoading = false;
        //     if (res.data.value.length > 0) {
        // this.formModel.Inactive = true;
        // e.component.beginUpdate();
        // e.component.option("value", true);
        // e.component.endUpdate();
        //       this.validationSummary = [];
        //       this.validationSummary.push({
        //         message: `${this.baseView.id} is associated with product records. This may not be marked inactive until it is no longer associated with product records.`,
        //       });
        //       this.validationSummary.push({
        //         message: `Tip: To identify the associated product use the filters on the product list.`,
        //       });
        //     }
        //   })
        //   .catch((err) => {
        //     if (err) this.setLoading = false;
        //   });
      }
    },
    beforeInit() {
      if (this.baseView.mode != "create" && this.baseView.id) {
        IntakeSeasonService.CheckSeasonUsed(this.baseView.id).then((res) => {
          if (res.data == false) this.recordEditable = true;
          else this.recordEditable = false;
        });
      } else {
        this.recordEditable = true;
      }
    },
    async deleteIntakeSeason() {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record ?",
        "Delete Record"
      );

      if (confirmDelete) {
        await IntakeSeasonService.deleteIntakeSeason(this.baseView.id).then(
          () => {
            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path: "/season",
              })
              .then(() => {
                this.$refs["intake-season"].$refs[
                  "split-view-grid"
                ].gridRefresh();
              });
          }
        );
      }
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
